
const ProjectsCarousel = () => {
  return (
    <section className="py-20 bg-white overflow-hidden">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex justify-between items-end mb-12">
          <div>
            <h2 className="text-5xl font-bold text-black mb-3">RECENT PROJECTS</h2>
            <div className="w-20 h-1 bg-yellow-500"></div>
          </div>
        </div>

        <div className="flex flex-col items-center justify-center py-20 border-2 border-dashed border-gray-200 rounded-2xl">
          <div className="w-16 h-16 flex items-center justify-center mb-4">
            <i className="ri-image-add-line text-5xl text-gray-300"></i>
          </div>
          <p className="text-xl font-semibold text-gray-400 mb-2">Project Photos Coming Soon</p>
          <p className="text-gray-400 text-sm text-center max-w-sm">
            Check back soon — we'll be showcasing our latest concrete pumping and stone work here.
          </p>
        </div>
      </div>
    </section>
  );
};

export default ProjectsCarousel;
